import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import DaySection from './DaySection'
import MomentCard from './MomentCard'
import { withMomentDays } from './withMomentDays'

const MomentDays = ({ loading, momentDays, userId }) => {
  if (loading) return null
  return (
    <React.Fragment>
      {_.map(momentDays, (moments, day) => {
        const dayMoment = moment(day)
        return (
          <DaySection key={day} dayTitle={dayMoment.format('LL')}>
            {_.map(moments, moment => (
              <MomentCard key={moment.id} moment={moment} userId={userId} />
            ))}
          </DaySection>
        )
      })}
    </React.Fragment>
  )
}

export default withMomentDays(MomentDays)



// WEBPACK FOOTER //
// ./src/components/templates/moment/MomentDays.js